export const COLORS = {
	yellow: "#FFEE00",
	white: "#FFFFFF",
	orange: "#FCB500",
	grey: "#ADADAD",
	black: "#111111"
};